import { render } from "./AgentAddEdit.vue?vue&type=template&id=e452b3b8&scoped=true"
import script from "./AgentAddEdit.vue?vue&type=script&lang=js"
export * from "./AgentAddEdit.vue?vue&type=script&lang=js"

import "./AgentAddEdit.vue?vue&type=style&index=0&id=e452b3b8&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Edukatta_Gov_Eticket\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e452b3b8"]])

export default __exports__